import { GetBodyBankAccountQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyBankAccount/getBodyBankAccountQuery.type';
import { getBodyBankAccountQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyBankAccount/getBodyBankAccountQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyBankAccountQueryOptions = (
  params: GetBodyBankAccountQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['Get_Body_Bank_Account', params],
    queryFn: () => getBodyBankAccountQueryFunction(params),
  });
};
